import type { MatchId } from "./types";
import type { Edge } from "./types/edge";
import type { Graph } from "./types/graph";
import type { TournamentNode } from "./types/node";

const getOrSetDefault = <K, V>(map: Map<K, V>, key: K, defaultValue: V): V => {
  if (!map.has(key)) map.set(key, defaultValue);
  return map.get(key)!;
};

export const computeRounds = <TNode extends TournamentNode>(
  graph: Graph<TNode>,
): Map<MatchId, number> => {
  const incoming = new Map<MatchId, Edge[]>();

  for (const e of graph.edges) {
    getOrSetDefault(incoming, e.to, []).push(e);
  }

  const rounds = new Map<MatchId, number>();

  const depth = (id: MatchId): number => {
    if (rounds.has(id)) return rounds.get(id)!;

    const inc = incoming.get(id) ?? [];

    const d = Math.max(
      0,
      ...inc
        .filter((e) => e.kind === "match")
        .map((e) => depth(e.from) + (e.outcome === "winner" ? 1 : 0)),
    );

    rounds.set(id, d);
    return d;
  };

  for (const id of graph.nodes.keys()) {
    depth(id);
  }

  return rounds;
};
